import { render, staticRenderFns } from "./asset_class.vue?vue&type=template&id=cfffb1d6"
import script from "./asset_class.vue?vue&type=script&lang=js"
export * from "./asset_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports